// tslint:disable: naming-convention
import { Action } from '@ngrx/store';
import { SpezifikationEntity } from '../../../entities/mdqx/spezifikation.entity';

export enum SpezifikationActionTypes {
    GetSpezifikationenRequest = '[Spezifikationen] Get Request',
    GetSpezifikationenResponse = '[Spezifikationen] Get Response',
}

export class GetSpezifikationenRequest implements Action {
    readonly type = SpezifikationActionTypes.GetSpezifikationenRequest;
}

export class GetSpezifikationenResponse implements Action {
    readonly type = SpezifikationActionTypes.GetSpezifikationenResponse;
    constructor(public Payload: SpezifikationEntity[]) {}
}

export type SpezifikationActions =
    | GetSpezifikationenRequest
    | GetSpezifikationenResponse;
